import(/* webpackMode: "eager" */ "/app/next-auth-app/app/globals.scss");
;
import(/* webpackMode: "eager" */ "/app/next-auth-app/app/fullcalendar.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/next-auth-app/components/Providers.tsx");
